import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientFormControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  patientId: string;
  pagination: DGT_Pagination;
  sortBy?: string;
  sortDirection?: string;
  xTENANTID?: string;
  status?: string[];
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetAllPatientForms = (
  props: Props
): useBaseContent<OptionData> => {
  const { xTENANTID, pagination, patientId, sortBy, sortDirection, status } = props;
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination: props?.pagination,
    searchKey: "",
    prevPage,
  });
  const pageSize = getPageSize("", props?.pagination);

  return useQuery({
    queryKey: [
      "patient-chart-forms-list",
      pageIndex,
      patientId,
      pagination,
      sortBy,
      sortDirection,
      xTENANTID,
      status,
    ],
    queryFn: async () =>
      await new PatientFormControllerApi(getConfigObject()).getAllPatientForms(
        patientId,
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        status,
        xTENANTID,
      ),
  });
};